<template>
  <main class="login">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png">
      <section>
        <h1>{{ $_getTranslations.visitor_sign_up_1_single_country_login }}</h1>

        <facebook-login v-if="facebookFunctionality"
                        :enteredUsername="testUser"
                        :type="fbActionType"
                        @errorsUpdated="methodForEvent($event)">
        </facebook-login>

        <div class="error_text par" v-if="errorInFb">
          {{ getMessage(errorInFb) }}
        </div>

        <div class="divider" v-if="facebookFunctionality">
          <span>{{ $_getTranslations.visitor_sign_up_and_login_or }}</span>
        </div>

        <base-text-form-input
          v-model="user.username"
          :input-class="'mobile'"
          :label="$_getTranslations.visitor_login_placeholder_enter_username"
          :invalid="user.hasErrors"
          input-name="user-username"
        ></base-text-form-input>

        <base-password-form-input
          v-model="user.password"
          :label="$_getTranslations.visitor_login_placeholder_enter_password"
          :invalid="user.hasErrors"
          input-name="user-password"
        ></base-password-form-input>

        <div class="error_text" v-show="getMessage(user.message)">{{ getMessage(user.message) }}</div>


        <div class="remember_checkbox">
          <input id="remember_me"
                 type="checkbox"
                 v-model="rememberMeParameter">
          <label for="remember_me">{{ $_getTranslations.common_remember_me }}</label>
        </div>

        <div class="info_links">
          <div class="pin_forgot flex-row">
            <img src="/static/images/info.svg">2
            <a style="cursor:pointer" @click.prevent="showPinModalAnimation()">{{ $_getTranslations.visitor_login_what_my_pin }}</a>
          </div>
          <router-link :to="'forgotPassword1'">{{ $_getTranslations.home_modals_change_login_pin_forgot }}</router-link>
        </div>

        <template v-if="showLoginEmail">
          <p class="login_email_txt">{{ $_getTranslations.visitor_login_description_email }}</p>

          <base-text-form-input
            :model-value="user.email"
            :label="$_getTranslations.visitor_login_placeholder_enter_email"
            :invalid="formValidation.email.error"
            input-id="email"
            input-class="email"
            input-name="user-email"
            @update:modelValue="handleEmailInputChange"
          ></base-text-form-input>

          <div
            class="error_text"
            v-show="formValidation.email.error && getMessage(formValidation.email.message)"
          >
            {{ getMessage(formValidation.email.message) }}
          </div>
        </template>

        <div class="outline_fancy_btn finish">
          <button type="submit" class="fancy_btn" @click.prevent="checkButton">{{ $_getTranslations.visitor_login_finish }}</button>
        </div>

        <p class="last_line login">{{$_getTranslations.visitor_login_new_here}}
          <a style="cursor:pointer" class="text_links login" @click.prevent="goToRegistration">{{ $_getTranslations.visitor_login_create_account }}</a>
        </p>

      </section>
    </form>
    <login-modal v-if="showPinModal"
                 @close="showPinModal = false;">
    </login-modal>

    <register-via-sms v-if="isRegisterViaSmsModalOpen"></register-via-sms>
  </main>

</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import IntegrationMixin from '../../common/mixins/integration';
import RegistrationFlowMixin from '../../common/mixins/flow';
import FacebookLogin from './FacebookLogin';
import LoginModal from "../home/modals/LoginModal";
import RegisterViaSms from '../home/modals/RegisterViaSms';
import BaseTextFormInput from "../common/formInput/BaseTextFormInput";
import translationMixin from "../../common/mixins/translation";
import BasePasswordFormInput from "../common/formInput/BasePasswordFormInput";
import modals from "../../common/modals";

const emailRegexValidation = /^\S+@\S+\.\S+$/;

export default {
  components: { BasePasswordFormInput, BaseTextFormInput, FacebookLogin, LoginModal, RegisterViaSms },
  name: 'login',
  mixins: [IntegrationMixin, RegistrationFlowMixin, translationMixin],
  data() {
    return {
      showPinModal: false,
      testUser: 'User',
      fbActionType: 'login',
      errorInFb: null,
      rememberMeParameter: true,
      user: {
        username: '',
        password: '',
        email: '',
        message: '',
        hasErrors: false,
      },
      isRegisterViaSmsModalOpen: false,
      formValidation: {
        email: {
          error: false,
          message: '',
        },
      },
    };
  },
  methods: {
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'callForAuthorization',
      'saveLoginEmail',
    ]),
    showPinModalAnimation() {
      this.showPinModal=true;
      modals.setupCommonModal();
    },
    goToRegistration() {
      if (!this.hasWebRegister()) {
        this.isRegisterViaSmsModalOpen = true;
        modals.setupCommonModal({
          afterHideCallback: () => {
            this.isRegisterViaSmsModalOpen = false;
          }
        });
      } else {
        this.registrationRedirect();
      }
    },
    getMessage(key) {
      return this.$_getTranslations[key] || '';
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    async registerLoginEmail (email) {
      try {
        await this.saveLoginEmail({ email });

        return { invalid: false };
      } catch (_e) {
        this.formValidation.email.error = true;
        this.formValidation.email.message = 'visitor_login_error_email_invalid';

        return { invalid: true };
      }
    },
    checkButton() {
      this.user.message = '';
      this.errorInFb = null;

      if (
        this.showLoginEmail &&
        this.user.email &&
        !this.user.email.match(emailRegexValidation)
      ) {
        this.formValidation.email.error = true;
        this.formValidation.email.message = 'visitor_login_error_email_invalid';

        return;
      }

      const userData = {
        username: this.user.username,
        password: this.user.password,
        rememberMe: this.rememberMeParameter,
      };
      this.callForAuthorization(userData).then(async () => {
        if (this.getUserAuthorized) {
          if (this.showLoginEmail && this.user.email) {
            const { invalid: invalidSaveEmailResponse } = await this.registerLoginEmail(this.user.email);

            if (invalidSaveEmailResponse) { return; }
          }

          this.getUserLoginDetails().then(() => {
            if (this.getUserAuthorized) {
              this.user.hasErrors = false;
              this.updateUserLanguage();
              this.$router.push('home');
            } else {
              this.user.message = 'visitor_login_server_error';
              this.user.hasErrors = true;
            }
          });
        } else {
          this.user.message = 'visitor_login_invalid_password';
          this.user.hasErrors = true;
          this.errorInFb = null;
        }
      });
    },
    change() {
      this.user.hasErrors = false;
      this.user.message = '';
      this.errorInFb = null;
    },
    handleEmailInputChange (value) {
        this.user.email = value;
        if (this.formValidation.email.error) {
            this.formValidation.email.error = false;
            this.formValidation.email.message = '';
        }
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
      'showLoginEmail',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Login.vue